export default "__VITE_ASSET__Fe0LNem8__"